import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormsModule, NgForm, ReactiveFormsModule } from "@angular/forms";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { BusyIndicatorComponent } from "@tylertech/common-components-module";
import { ForgeButtonModule, ForgeCardModule } from "@tylertech/forge-angular";
import { Utilities } from "@tylertech/shared-module";
import { ClassMetadata, ICardMetadata } from "@tylertech/tyler-api-types";
import { MetadataPanelComponent } from "../metadataPanel/metadataPanel.component";

@Component({
    selector: "metadata-card-edit",
    templateUrl: "./metadataCard.edit.tmpl.html",
    imports: [
        BusyIndicatorComponent,
        LayoutAlignDirective,
        LayoutDirective,
        ForgeButtonModule,
        ForgeCardModule,
        FormsModule,
        MetadataPanelComponent,
        ReactiveFormsModule,
    ]
})
export class MetadataCardEditComponent implements OnInit
{
    @Input()
    cardMetadata: ICardMetadata;

    @Input()
    model: any;

    @Output()
    readonly toggleEdit = new EventEmitter<void>();

    @Input()
    dense: boolean;

    @Output()
    readonly overrideSave = new EventEmitter<void>();

    @ViewChild("form") form: NgForm;

    metadata: ClassMetadata;

    loading: boolean = false;

    outlined: boolean = false;

    ngOnInit(): void
    {
        this.loading = true;
        this.initialize();
    }

    private initialize(): void
    {
        this.metadata = this.cardMetadata.EditMetadata;
        if (!this.metadata) this.metadata = this.cardMetadata.ViewMetaData;
        this.loading = false;
    }

    formIsValid(): boolean
    {
        return Utilities.IsNullOrUndefined(this.form) ? true : !this.form.invalid;
    }

    cancel(): void
    {
        this.toggleEdit.emit();
    }

    save(): void
    {
        this.overrideSave.emit();
    }
}
